export function extractTranscriptText(payload) {
  if (!payload) {
    return "";
  }

  if (typeof payload === "string") {
    return payload.trim();
  }

  if (typeof payload.full_text === "string") {
    return payload.full_text.trim();
  }

  return "";
}
